<template>
  <div class="share-poster">
    <div v-for="(item, index) in invArr" :key="index" class="van-swipe van-position">
      <div class="van-swipe-item">
        <div class="swiper-con" :id="`swiper${index}`">
          <img :src="item" class="item-cover" crossorigin="anonymous" :id="`cover${index}`" alt="">
          <div class="cod-div">
            <div :id="`qrCode${index}`" class="code-img" :ref="`qrCode${index}`"></div>
          </div>
          <div class="username">{{ user_info.nickname }}</div>
          <div class="inv-code">{{ user_info.inv_code }}</div>
        </div>
      </div>
    </div>
    <van-swipe :loop="false" @change="handleSwiperChange">
      <van-swipe-item v-for="(item, index) in swiperImgs"
        :class="curSwiperIndex === index ? 'cur' : (curSwiperIndex + 1) === index ? 'next' : (curSwiperIndex - 1) === index ? 'prev' : ''"
        :key="index">
        <div class="swiper-con">
          <img :src="item.imgSrc" v-if="!item.isLoading" class="item-cover" alt="">
          <van-loading v-else type="spinner" />
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="txt-tip">长按图片保存转发给朋友</div>
    <div class="div-custom" @click="handleJump">
      <img src="@/assets/images_member/per1 (27).png" class="div-bg" alt="">
      <div class="txt">我的客户</div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
import { invcode } from '@/api/person'
export default {
  name: 'SharePoster',
  data () {
    return {
      invArr: [],
      curSwiperIndex: 0,
      codeSrc: '',
      user_info: {},
      swiperImgs: []
    }
  },
  mounted () {
    let params = {
      pos: 'vip_poster'
    }
    invcode(params).then(res => {
      console.log('res', res)
      this.invArr = res.data.poster
      this.code = res.data.inv_code
      this.user_info = res.data.user_info
      this.makeCode()
    }).catch(error => {
      console.log(error)
    })
  },
  methods: {
    handleJump () {
      this.$router.push({
        path: '/custom'
      })
    },
    handleSwiperChange (e) {
      this.curSwiperIndex = e
    },
    makeCode () {
      this.$nextTick(() => {
        this.invArr.map((res, index) => {
          let idDom = document.getElementById('qrCode' + index)
          let qrcode = new QRCode(idDom, {
            text: `https://vip.xf-market.com/pageHome?qrCode=${this.code}`,
            width: idDom.clientWidth,
            height: idDom.clientHeight,
            colorDark: '#333333', // 二维码颜色
            colorLight: '#ffffff', // 二维码背景色
            correctLevel: QRCode.CorrectLevel.L// 容错率，L/M/H
          })
          console.log(qrcode)
          this.swiperImgs.push({
            imgSrc: '',
            isLoading: true
          })
          this.draw(index)
        })
      })
    },
    // 长按事件（起始）
    // gtouchstart (item, index) {
    //   var self = this
    //   this.timeOutEvent = setTimeout(function () {
    //     self.longPress(index)
    //   }, 500) // 这里设置定时器，定义长按500毫秒触发长按事件
    //   return false
    // },
    // // 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    // showDeleteButton (item) {
    //   clearTimeout(this.timeOutEvent) // 清除定时器
    //   if (this.timeOutEvent !== 0) {
    //     // 这里写要执行的内容（如onclick事件）
    //     console.log('点击但未长按')
    //   }
    //   return false
    // },
    // // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    // gtouchmove () {
    //   clearTimeout(this.timeOutEvent) // 清除定时器
    //   this.timeOutEvent = 0
    // },
    // // 真正长按后应该执行的内容
    // longPress (index) {
    //   this.timeOutEvent = 0
    //   // 执行长按要执行的内容，如弹出菜单
    //   console.log('长按', index)
    //   this.draw(index)
    // },
    draw (index) {
      const ref = document.getElementById('swiper' + index) // 截图区域
      html2canvas(ref, {
        backgroundColor: 'transparent',
        height: ref.scrollHeight - 1,
        width: ref.scrollWidth,
        useCORS: true // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png')
        this.swiperImgs[index].imgSrc = dataURL
        this.swiperImgs[index].isLoading = false
      })
    }

  }
}
</script>
<style lang="less" scoped>
.share-poster {
  width: 100vw;
  min-height: 100vh;
  background-color: #1E2020;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none;

  .txt-tip {
    font-size: 16px;
    color: #FFFFFF;
    font-weight: 500;
    margin-top: 34px;
    text-align: center;
  }

  .div-custom {
    width: 60px;
    height: 70px;
    text-align: center;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;

    .div-bg {
      width: 100%;
      height: 100%;
      display: block;
    }

    .txt {
      font-size: 12px;
      color: #FFFFFF;
      font-weight: 500;
      margin-top: -22px;
    }
  }

  .van-position {
    position: absolute;
    top: -1000px;
    left: -1000px;
  }

  /deep/ .van-swipe {
    padding-top: 92px;
    padding-left: 58px;
    height: 462px;

    .van-loading {

      position: absolute;
      left: 30%;
      top: 40%;
    }

    .van-swipe-item {
      transition: all .5s;
      position: relative;

      &.prev {
        transform: translateX(100px) scale(.9);
      }

      &.next {
        transform: translateX(-110px) scale(.9);
      }

      &.cur {
        transform: translateX(0) scale(1);
      }

      .swiper-con {
        width: 260px;
        height: 462px;
      }

      .item-cover {
        width: 260px;
        height: 462px;
        border-radius: 20px;
        overflow: hidden;
        margin-right: 30px;
        display: block;
        object-fit: cover;
      }

      .cod-div {
        width: 68px;
        height: 68px;
        border-radius: 6px;
        position: absolute;
        bottom: 10px;
        padding: 5px;
        left: 182px;
        box-sizing: border-box;

        .code-img {
          width: 58px;
          height: 58px;

          img {
            width: 58px;
            height: 58px;
          }
        }
      }

      .username {
        position: absolute;
        line-height: 20px;
        left: 20px;
        color: #FFFFFF;
        font-size: 14px;
        bottom: 110px;
      }
      .inv-code {
        position: absolute;
        color: #999;
        font-size: 14px;
        left: 62px;
        top: 354px;
      }
    }

    .van-swipe__indicators {
      display: none;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/sharePoster.vue